export default __webpack_public_path__ + "static/media/guesty_step9.06dda8c9.png";